.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(16, 13, 10, 0.6);
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: overlayIn 0.2s ease both;
}
.panel {
  width: min(88vw, 356px);
  background: #ffffff;
  border: 1px solid var(--rule-2);
  border-radius: 22px;
  padding: 26px 20px;
  box-shadow: 0 24px 60px rgba(40, 30, 15, 0.28);
  text-align: center;
  animation: popIn 0.28s ease both;
  max-height: 84vh;
  max-height: 84svh;
  overflow: auto;
  box-sizing: border-box;
}
.title {
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 2px;
  color: var(--ink-2);
}
.subtitle {
  margin-top: 6px;
  font-family: var(--font-label);
  font-size: 12.5px;
  color: var(--muted);
}
.dropzone {
  display: block;
  border: 1.5px dashed var(--muted-5);
  border-radius: 16px;
  padding: 26px 14px;
  margin-top: 16px;
  cursor: pointer;
  background: #fffdf6;
}
.dropzoneDisabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.dropzoneText {
  font-family: var(--font-label);
  font-size: 12.5px;
  color: var(--muted);
  line-height: 1.9;
}
.input {
  display: none;
}
.count {
  margin-top: 12px;
  font-family: var(--font-label);
  font-size: 12.5px;
  letter-spacing: 0.5px;
  color: var(--ink-3);
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 12px;
}
.tile {
  aspect-ratio: 1 / 1;
  border-radius: 9px;
  overflow: hidden;
  border: 1px solid #e4dbc6;
  background: var(--sand);
}
.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.remainder {
  margin-top: 8px;
  font-family: var(--font-label);
  font-size: 11.5px;
  color: var(--muted-4);
}
.progress {
  margin-top: 16px;
}
.progressTrack {
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: var(--rule-3);
  overflow: hidden;
}
.progressFill {
  height: 100%;
  background: var(--pink);
  transition: width 0.2s ease-out;
}
.progressLabel {
  margin-top: 6px;
  font-family: var(--font-label);
  font-size: 11px;
  color: var(--muted);
}
.actions {
  display: flex;
  gap: 8px;
  margin-top: 18px;
}
.closeBtn {
  flex: 1;
  border: 1px solid #dae0e7;
  border-radius: 999px;
  background: #ffffff;
  padding: 11px 0;
  font-family: var(--font-label);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 2px;
  color: var(--muted);
  cursor: pointer;
}
.closeBtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.sendBtn {
  flex: 1;
  border: none;
  border-radius: 999px;
  background: var(--pink);
  padding: 12px 0;
  font-family: var(--font-label);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 2px;
  color: #fffdf6;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(16, 26, 43, 0.3);
}
.sendBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
